export default [
    // {
    //     path: "/api-key",
    //     name: "ApiKey",
    //     component: () => import("@/views/apiKey"),
    //     meta: {title: "Api Key", activeMenu: "/api-key"},
    // },
    {
        path: "/model-overview",
        name: "ModelOverview",
        component: () => import("@/views/modelOverview"),
        meta: {title: "模型广场", activeMenu: "/model-overview"},
    },
    {
        path: "/app-store",
        name: "AppStore",
        component: () => import("@/views/app-store"),
        meta: {title: "应用广场", activeMenu: "/app-store"},
    },
    {
        path: "/model-overview/detail/:id",
        name: "ModelOverviewDetail",
        component: () => import("@/views/modelOverview/detail"),
        meta: {title: "模型详细", activeMenu: "/model-overview"},
    },
    {
        path: "/ai-tools",
        name: "AiTools",
        component: () => import("@/views/aiTools"),
        meta: {title: "应用工具", activeMenu: "/ai-tools"},
    },
    {
        path: "/ai-tools/detail/:id",
        name: "AiToolsDetail",
        component: () => import("@/views/aiTools/detail"),
        meta: {title: "应用工具详细", activeMenu: "/ai-tools"},
    },
    {
        path: "/model-overview/model-trial/:id",
        name: "ModelTrial",
        component: () => import("@/views/modelOverview/model-trial"),
        meta: {title: "模型体验"},
    },
]
